import React from "react";

import { message, Popover } from "antd";

import { Link, Switch, Route } from "react-router-dom";

import { SessionStore, LocaleStore, RouterStore } from "@/stores";
import { inject, observer } from "mobx-react";

import CopyToClipboard from "react-copy-to-clipboard";
import "./index.less";
import MyIcon from "../MyIcon";
import QQgroup from "@/assets/images/qq_qrcode.png";
import { project, assets, footerLink, footerContact, footerInfo } from "@/config.json";

import QRCode from "qrcode.react";
import { loadImage } from "@/utils";

const mapUrl = {
  ZH: {
    Pool: "https://pool.mempool.com",
    Lastpurse: "https://www.dotwallet.com/",
    // MiningSet: "#",
    Notice:
      "https://support.mempool.com/hc/zh-cn/sections/360004150954-%E9%80%9A%E7%9F%A5%E5%85%AC%E5%91%8A",
    Guide: "https://support.mempool.com/hc/zh-cn",
    Feedback: "https://support.mempool.com/hc/zh-cn/requests/new",
    Blockchain: "https://www.blockchain.cn",
    blockchair: "https://blockchair.com/",
    about: "https://www.mempool.com/about",
  },
  EN: {
    Pool: "https://pool.mempool.com",
    Lastpurse: "https://www.dotwallet.com/",
    // MiningSet: "#",
    Notice: "https://support.mempool.com/hc/en-us/sections/360004150954-Notice-and-announcement",
    Guide: "https://support.mempool.com/hc/en-us",
    Feedback: "https://support.mempool.com/hc/zh-cn/requests/new",
    Blockchain: "https://www.blockchain.cn",
    blockchair: "https://blockchair.com/",
    about: "https://www.mempool.com/en/about",
  },
};
interface FooterProps {
  session: SessionStore;
  router: RouterStore;
  locale: LocaleStore;
}

@inject("session", "locale", "router")
@observer
class Footer extends React.Component<FooterProps, any> {
  constructor(props) {
    super(props);
  }

  state = {
    serviceUrl: "",
  };

  componentDidMount() {
    this.getOneAppVersion();
    loadImage(assets.service).then((asset) => {
      this.setState({
        serviceUrl: asset.default,
      });
    });
  }

  getOneAppVersion = async () => {
    await this.props.session.getOneAppVersion();
  };

  render() {
    const { locale, session } = this.props;
    const langtype = locale.getLangType;
    const defaultMapUrl = mapUrl[langtype] ? mapUrl[langtype] : mapUrl.EN;

    return (
      <div className="mempool-footer">
        <div className="footer">
          <div className="center">
            <div className="footer-left">
              <div className="top">
                <MyIcon
                  type={`icon-${project}`}
                  className="logo-size"
                  onClick={() => this.props.router.push("/home")}
                />

                {/* {timeZoneJson[String(userInfo.time_zone)]} */}
                <span className="time-zone">
                  UTC{" "}
                  {session.userinfo.time_zone > 0
                    ? `+${session.userinfo.time_zone}`
                    : session.userinfo.time_zone}
                </span>
              </div>

              <div className="icon-group">
                {footerContact.qq ? (
                  <Popover
                    placement="bottomLeft"
                    // overlayClassName="footerLeft-overlay"
                    content={
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          flexDirection: "column",
                          cursor: "pointer",
                        }}
                      >
                        <img src={QQgroup} height="80px" />
                        <div>
                          {locale.get("Footer.QQGroup")}：{footerContact.qq}
                        </div>
                      </div>
                    }
                  >
                    <MyIcon type="icon-qq" className="icon-size-qq" />
                  </Popover>
                ) : null}
                {footerContact.phone ? (
                  <Popover
                    placement="bottomLeft"
                    content={
                      <div
                        style={{
                          width: "240px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          cursor: "pointer",
                        }}
                      >
                        <div>{footerContact.phone}</div>
                        <CopyToClipboard
                          text={footerContact.phone}
                          onCopy={() =>
                            message.success(locale.get("SubSettingObserver.CopySuccess"))
                          }
                        >
                          <div style={{ textDecoration: "underline" }}>
                            {locale.get("Footer.copy")}
                          </div>
                        </CopyToClipboard>
                      </div>
                    }
                  >
                    <MyIcon type="icon-mobile" className="icon-size-mobile" />
                  </Popover>
                ) : null}
                {footerContact.email ? (
                  <Popover
                    placement="bottomLeft"
                    content={
                      <div
                        style={{
                          width: "200px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          cursor: "pointer",
                        }}
                      >
                        <div>{footerContact.email}</div>
                        <CopyToClipboard
                          text={footerContact.email}
                          onCopy={() =>
                            message.success(locale.get("SubSettingObserver.CopySuccess"))
                          }
                        >
                          <div style={{ textDecoration: "underline" }}>
                            {locale.get("Footer.copy")}
                          </div>
                        </CopyToClipboard>
                      </div>
                    }
                  >
                    <MyIcon type="icon-email" className="icon-size-email" />
                  </Popover>
                ) : null}
                {footerContact.twitter ? (
                  <Popover
                    placement="bottomLeft"
                    content={
                      <div
                        style={{
                          width: "240px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          cursor: "pointer",
                        }}
                      >
                        <div>Twitter：{footerContact.twitter}</div>
                        <CopyToClipboard
                          text={footerContact.twitter}
                          onCopy={() =>
                            message.success(locale.get("SubSettingObserver.CopySuccess"))
                          }
                        >
                          <div style={{ textDecoration: "underline" }}>
                            {locale.get("Footer.copy")}
                          </div>
                        </CopyToClipboard>
                      </div>
                    }
                  >
                    <MyIcon type="icontwitter" className="icon-size-qq" />
                  </Popover>
                ) : null}
                {footerContact.telegram ? (
                  <Popover
                    placement="bottomLeft"
                    content={
                      <div
                        style={{
                          width: "240px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          cursor: "pointer",
                        }}
                      >
                        <div>Telegram: {footerContact.telegram}</div>
                        <CopyToClipboard
                          text={footerContact.telegram}
                          onCopy={() =>
                            message.success(locale.get("SubSettingObserver.CopySuccess"))
                          }
                        >
                          <div style={{ textDecoration: "underline" }}>
                            {locale.get("Footer.copy")}
                          </div>
                        </CopyToClipboard>
                      </div>
                    }
                  >
                    <MyIcon type="icontelegram" className="icon-size-mobile" />
                  </Popover>
                ) : null}
              </div>

              <div className="font-14">
                {footerInfo.copyright}
                {footerInfo.nationalRecord ? (
                  <div>
                    <a target="_blank" href="http://beian.miit.gov.cn/">
                      {footerInfo.nationalRecord}
                    </a>
                  </div>
                ) : null}
              </div>

              <div className="font-14">
                {locale.isCN && footerInfo.securityRecord ? (
                  <div>
                    <a
                      target="_blank"
                      href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35010402350905"
                    >
                      <img
                        src="https://static.ddpurse.com/asset/beian.png"
                        height="18px"
                        style={{ marginRight: "5px" }}
                      />
                      <span>{footerInfo.securityRecord}</span>
                    </a>
                  </div>
                ) : null}
              </div>
            </div>
            <div className="footer-middle">
              {/* zc 添加 */}
              <div className="cloumn-none"></div>
              {/* 产品 */}
              {footerLink.enableProducts ? (
                <div className="cloumn-middle">
                  <span className="title-bottom">{locale.get("Footer.Products")}</span>
                  <a target="_blank" href={defaultMapUrl.Pool}>
                    {locale.get("Footer.Pool")}
                  </a>
                  {/* <a target="_blank" href={defaultMapUrl.Lastpurse}>
                    {locale.get("Footer.Lastpurse")}
                  </a> */}
                </div>
              ) : (
                <div className="cloumn-none"></div>
              )}
              {/* 帮助中心 */}
              {/* {footerLink.enableHelpCenter ? (
                <div className="cloumn-middle">
                  <span className="title-bottom">{locale.get("Footer.Help")}</span>
                  <a target="_blank" href={defaultMapUrl.Notice}>
                    {locale.get("Footer.Notice")}
                  </a>
                  <a target="_blank" href={defaultMapUrl.Guide}>
                    {locale.get("Footer.Guide")}
                  </a>
                  <a target="_blank" href={defaultMapUrl.Feedback}>
                    {locale.get("Footer.Feedback")}
                  </a>
                </div>
              ) : (
                <div className="cloumn-none"></div>
              )} */}
              {/* 联系我们 */}
              <div className="cloumn-middle">
                <span className="title-bottom">{locale.get("Footer.Links")}</span>

                {/* <a target="_blank" href={defaultMapUrl.about}>
                  {locale.get("Footer.Aboutus")}
                </a> */}
                <Link to={"/service"}>{locale.get("Footer.CustomerServices")}</Link>
              </div>
              {/* 友情链接 */}
              {/* {footerLink.enableFriendShipLink ? (
                <div className="cloumn-middle">
                  <span className="title-bottom">{locale.get("Footer.Link")}</span>
                  <a target="_blank" href={defaultMapUrl.Blockchain}>
                    {locale.get("Footer.Blockchain")}
                  </a>
                  <a target="_blank" href={defaultMapUrl.blockchair}>
                    {locale.get("Footer.blockchair")}
                  </a>
                </div>
              ) : null} */}
            </div>
            <div className="footer-right">
              <div className="cloumn-right">
                <span className="title-bottom">{locale.get("Footer.AddWeChat")}</span>
                {/* <img src={this.state.serviceUrl} /> */}
                <img src={this.state.serviceUrl} />
              </div>
              {/* {footerLink.enableApp ? (
                <div className="cloumn-right">
                  <span className="title-bottom">Mempool App</span>
                  <QRCode value={session.link || ""} size={70} className="code-bg" />
                  <span className="text-bottom">{locale.get("Footer.Android")}</span>
                </div>
              ) : null} */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer as React.ComponentType;
